import { render, staticRenderFns } from "./ApdType.vue?vue&type=template&id=3c5c619a&scoped=true&"
import script from "./ApdType.vue?vue&type=script&lang=js&"
export * from "./ApdType.vue?vue&type=script&lang=js&"
import style0 from "./ApdType.vue?vue&type=style&index=0&id=3c5c619a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5c619a",
  null
  
)

export default component.exports